import { render, staticRenderFns } from "./MobileUtilPages.vue?vue&type=template&id=bee902f2&scoped=true"
import script from "./MobileUtilPages.vue?vue&type=script&lang=js"
export * from "./MobileUtilPages.vue?vue&type=script&lang=js"
import style0 from "./MobileUtilPages.vue?vue&type=style&index=0&id=bee902f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee902f2",
  null
  
)

export default component.exports